import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { getEndpoint } from 'src/app/core/services/functions.service';

@Injectable({
  providedIn: 'root'
})
export class AsignarProveedorService {
  private readonly webhookUrl = `${getEndpoint('proveedor_chat')}`;

  constructor(private http: HttpClient) {}

  sendChatMessage(sessionId: string, message: string): Observable<any> {
    const request = {
      sessionId,
      action: 'sendMessage',
      chatInput: message
    };
    return this.http.post<any>(this.webhookUrl, request);
  }
}